<ion-tabs>
  <ion-tab-bar slot="bottom" class="tab-bar">
    <ion-tab-button *ngFor="let tab of tabs" [tab]="tab.tab" class="tab-button">
      <ion-icon [name]="tab.icon" class="icon-color-primary"></ion-icon>
      <ion-label class="text-color-primary button-font-size-m">{{tab.name}}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
